import React from 'react';
import { Container, Heading } from '@hover/blueprint';
import SignUpCTAForm from '../SignUpCTAForm';

const DownloadAppModalMobile: React.FC = () => (
  <Container
    d={{ base: 'flex', tablet: 'none' }}
    flexDir="column"
    h="100vh"
    pt={1000}
    px={500}
    maxW="100vw"
  >
    <Heading size={600} isLight textAlign="center">
      Build your better tomorrow today
    </Heading>
    <Heading size={300} isDisplay marginBottom={800} textAlign="center">
      HOVER makes home improvement simpler, faster and more collaborative for
      homeowners and pros.
    </Heading>
    <SignUpCTAForm
      inputColor="brandNavy.600"
      inputBackground="neutral.100"
      contentColor="neutral.600"
      linkColorScheme="primary"
    />
  </Container>
);

export default DownloadAppModalMobile;
